'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VAlert = undefined;

var _VAlert = require('./VAlert');

var _VAlert2 = _interopRequireDefault(_VAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.VAlert = _VAlert2.default;
exports.default = _VAlert2.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VAlert/index.js
// module id = 179
// module chunks = 0